import React from 'react';
import { Form } from 'react-form';
import { connect } from 'react-redux';
import _ from 'lodash';
import Translate from 'translate';

import DeleteModal from 'components/HTMLElements/DeleteModal';
import { FormGroup, Textarea } from 'components/FormElements';
import { toggleLoading, toggleAlertError } from 'stores/actions';
import BroadcastService from "services/BroadcastService";
import { required } from "constants/InputErrors";
import Dropzone from "react-dropzone";

class NetworkForm extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      sendMsgModalOpened: false,
      fileError: null
    };
  }

  submitForm = () => {
    const { toggleAlertError, toggleLoading, type } = this.props;
    toggleLoading( true );

    const dataToSend = _.clone( this.msgData );
    dataToSend.type = type;
    BroadcastService.sendBroadcast( {
      ...dataToSend,
      attachment: dataToSend.attachments ? dataToSend.attachments[0] : undefined,
      attachments: undefined
    } ).then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      this.toggleSendMsgModal();
      toggleAlertError( 'Message Sent' );
      this.resetForm();
    } )
  };

  toggleSendMsgModal = ( data ) => {
    this.msgData = data;
    this.setState( { sendMsgModalOpened: !this.state.sendMsgModalOpened } );
  };

  render() {
    const { networkSettings, type } = this.props;
    const { fileError } = this.state;

    return (
      <div className="box box-default">
        <div className="box-header">
          <Translate id="newBroadcastMsg"/>
        </div>
        <div className="box-body">
          <Form
            onSubmit={this.toggleSendMsgModal}
            validate={( values ) => {
              return {
                content: required( values.content ),
              }
            }}>
            {( { submitForm, resetForm, getValue, setValue, removeValue } ) => {
              this.resetForm = resetForm;
              return (
                <form onSubmit={submitForm}>
                  <FormGroup>
                    <label><Translate id="Content"/></label>

                    {type === 'twitter' &&
                    <Textarea field="content" className="form-control" rows={8}
                              maxLength={networkSettings.twitterLimit !== -1 ? networkSettings.twitterLimit : null}/>
                    }
                    {type === 'facebook' &&
                    <Textarea field="content" className="form-control" rows={8}
                              maxLength={networkSettings.facebookLimit !== -1 ? networkSettings.facebookLimit : null}/>
                    }

                    {type === 'twitter' && networkSettings.twitterLimit !== -1 &&
                    <span className="ml-3 color-gray-4">
                      {getValue( 'content' )
                        ? networkSettings.twitterLimit - getValue( 'content' ).length : networkSettings.twitterLimit}
                        {' '}
                        <Translate id="remainingCharacters"/>
                    </span>
                    }
                    {type === 'facebook' && networkSettings.facebookLimit !== -1 &&
                    <span className="ml-3 color-gray-4">
                      {getValue( 'content' )
                        ? networkSettings.facebookLimit - getValue( 'content' ).length : networkSettings.facebookLimit}
                      {' '}
                      <Translate id="remainingCharacters"/>
                    </span>
                    }
                  </FormGroup>

                  {!getValue( 'attachments' ) || getValue( 'attachments' ).length === 0 ?
                    <Dropzone
                      className="d-inline"
                      multiple={false}
                      maxSize={1000000}
                      accept="image/*"
                      onDrop={( files, invalidFiles ) => {
                        if( invalidFiles && invalidFiles.length ) this.setState( { fileError: 'fileErrorSizeOneMb' } )
                        else this.setState( { fileError: null } )
                        setValue( 'attachments', getValue( 'attachments' ) ? getValue( 'attachments' ).concat( ...files ) : files )
                      }}>
                      <i className="fa fa-paperclip mr-1"/>
                      <span className="color-gray-4 pointer font-weight-light"><Translate id="AttachFile"/></span>
                      {fileError ?
                        <span className="color-danger d-block">
                          <Translate id={fileError}/>
                        </span> : ''}
                    </Dropzone> : null
                  }

                  {_.map( getValue( 'attachments' ), ( file, index ) => {
                      return <div key={index}
                                  className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                        {file.name}
                        <i className="fa icon-close pointer"
                           onClick={() => removeValue( 'attachments', index )}/>
                      </div>
                    }
                  )}

                  <div className="text-right mt-4">
                    <button type="submit" className="btn btn-info px-4"><Translate id="send"/></button>
                  </div>
                </form>
              )
            }}
          </Form>
        </div>
        <DeleteModal label={<Translate id="youSureBroadCastMsg"/>}
                     onConfirm={this.submitForm}
                     opened={this.state.sendMsgModalOpened}
                     onToggle={this.toggleSendMsgModal}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  networkSettings: state.settings.networkSettings
} );

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( NetworkForm );



// WEBPACK FOOTER //
// ./routes/app/components/Broadcast/NetworkForm/index.js